module.exports = __webpack_public_path__ + "static/img/03.14667bde.png";